(function (angular) {
	'use strict';

	angular
		.module('investorOwnedModule')
		.directive('sliderIcon', [
			'$document',
			'$timeout',
			'STATIC_BASE_PATH',
			sliderIconFunction
		]);

	function sliderIconFunction($document, $timeout, STATIC_BASE_PATH) {
		return {
			restrict: 'E',
			replace: true,
			templateUrl: STATIC_BASE_PATH + '/' + 'static/html/ria/investor-owned/investor-owned-slider-icon.html',
			scope: {
				containerOffset: '@',
				iconWidth: '@',
				elementWidth: '@',
				mixpanelContainer: '@',
				overlayWidth: '=',
				initialTransition: '='
			},
			link: function ($scope, $elem, $attrs) {
				var iconOffset = 40;
				var containerLimitRight = parseInt($scope.elementWidth) - parseInt($scope.iconWidth);
				var startX = iconOffset;
				var positionX = iconOffset;
				var initialTransitionComplete = false;
				var touchScreen = false;

				$elem.css({
					position: 'absolute',
					left: '20px',
					transition: '1s all ease'
				});
				
				$elem.on('mousedown', function(event) {
					event.preventDefault();
					startX = event.pageX - positionX;
					$document.on('mousemove', moveIcon);
					$document.on('mouseup', releaseIcon);
				});
				
				$elem.on('touchstart', function(event){
					event.preventDefault();
					startX = event.touches[0].pageX - positionX;
					touchScreen = true;
					$document.on('touchmove', moveIcon);
					$document.on('touchend', releaseIcon);
				});

				$scope.$on('investorOwner:fullyExpandIcon', function(){
					transitionAnimation();
					expandIcon(containerLimitRight);
				});
				
				$scope.$watch('initialTransition', function(){
					if ($scope.initialTransition && !initialTransitionComplete){
						initialTransitionComplete = true;
						initialSlideOut();
					}
				});

				function moveIcon(event) {
					positionX = touchScreen ? event.touches[0].pageX - startX : event.pageX - startX;
					
					if (positionX > 0 && positionX <= containerLimitRight) {
						$scope.$apply(function(){
							$scope.overlayWidth = parseInt(positionX) + (parseInt($scope.iconWidth) / 2);
						});
						
						$elem.css({
							left: positionX + 'px'
						});
					}
				}
				
				function releaseIcon(){
					if (touchScreen){
						$document.off('touchmove', moveIcon);
						$document.off('touchend', releaseIcon);
					} else {
						$document.off('mousemove', moveIcon);
						$document.off('mouseup', releaseIcon);
					}

					mixpanel.track('Investor Owned Slider Used', {
						Section: $scope.mixpanelContainer
					});
				}
				
				function expandIcon(amount){
					positionX = amount;

					$elem.css({
						left: positionX + 'px'
					});
				}

				function transitionAnimation(overlayWidth){
					$elem.css({
						'transition': '1s all ease'
					});

					expandIcon(overlayWidth);

					$timeout(function () {
						$elem.css({
							'transition': 'none'
						});
					}, 1000);
				}

				function initialSlideOut(){
					var overlayWidth = 200;
					transitionAnimation(overlayWidth);
				}
			}
		};
	}
})(window.angular);